<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<form id="FormCategoriaGaleria" class="form-horizontal" method="post" autocomplete="off" onSubmit="return false">
				<div class="container-fluid">
					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12">
							<div class="form-group form-row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label for="Categoria">Categoría</label>
									<input type="text" v-model="objCategoriaGaleria.Categoria" class="form-control" id="Categoria" placeholder="Ingresar Categoría" />
									<CValidation v-if="this.errorvalidacion.Categoria" :Mensaje="'*'+errorvalidacion.Categoria[0]"/>
								</div>
							</div>
		
							<div class="form-group form-row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label for="EstatusAct">Estatus</label>
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" v-model="ChkValor" @change="SetearEstatus()" value="" id="EstatusAct">
                                        <label class="form-check-label" for="EstatusAct">
                                            <span v-if="objCategoriaGaleria.EstatusAct>0">Activo</span>
                                            <span v-else>Inactivo</span>
                                        </label>
                                    </div>
								</div>
							</div>
								
							<br>
						</div><!--fin col-12-->
					</div>
				</div>
			</form>
		</template>
	</CLoader>
</template>

<script>

export default {
    name: 'FormCategoriaGaleria',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objCategoriaGaleria: {
				IdCategoriaGaleria: 0,
				Categoria: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				EstatusAct: 0,
            },
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
            ChkValor: false,
        }
    },
    methods :
    {
       	async Guardar()
        {
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;

			if(this.objCategoriaGaleria.IdCategoriaGaleria == 0) {
				await this.$http.post(
					'categoriasGaleria',this.objCategoriaGaleria
				).then((res)=>{
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			} else {
				await this.$http.put(
					'categoriasGaleria/'+this.objCategoriaGaleria.IdCategoriaGaleria,
					this.objCategoriaGaleria
				).then((res)=>{                 
					this.EjecutaConExito(res);
				}).catch(err=>{   
					this.EjecutaConError(err);
				});
			}
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		Recuperar()
        {
            this.$http.get(
                "categoriasGaleria/"+this.objCategoriaGaleria.IdCategoriaGaleria
            ).then((res) => {
                this.objCategoriaGaleria = res.data.data;
                
                if(this.objCategoriaGaleria.EstatusAct == 1){
                    this.ChkValor = true;
                }
                else{
                    this.ChkValor = false;
                }

            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objCategoriaGaleria = {
				IdCategoriaGaleria: 0,
				Categoria: '',
				IdEmpresa: 0,
				IdSucursal: 0,
				EstatusAct: 0,
            }
            this.errorvalidacion = [];
            this.ChkValor = false;
        },
        SetearEstatus()
        {
            if(this.ChkValor){
                this.objCategoriaGaleria.EstatusAct = 1;
            }
            else{
                this.objCategoriaGaleria.EstatusAct = 0;
            }
        }
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();
                
            if (Id!='') 
            {
                this.objCategoriaGaleria.IdCategoriaGaleria = Id;
                this.Recuperar();
            }
            else
            {
                this.ConfigLoad.ShowLoader = false;
            }
        });
    }
}
</script>
